import React, {useEffect, useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction,toJS} from "mobx";
import PropTypes from "prop-types";
import EvaSingleFile from "../../defined/EvaSingleFile";
import StandaloneSingleFile from "../StandAlone/StandaloneSingleFile";
import {ComponentContext} from "../../contexts";
import AnalyzerView from "./AnalyzerView";

function Import(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compStore=useContext(ComponentContext);

  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  if(compStore.analyze.inited) {
    return (
      <AnalyzerView />
    )
  }

  return (
    <div className="pbottom20">
      <div className="pbottom20">
        <div className="up12 margin">
          <div className="cell s-auto">
            <h2>Загрузите CSV файл</h2>
          </div>
          <div className="cell s-shrink s-top">
            <span className="fs32 mdi mdi-close b1 pointer" onClick={()=>{ compStore.closeImport(); }}></span>
          </div>
        </div>

      </div>
      <StandaloneSingleFile onChange={(data)=>{
        if(data.tmp_file) {
          compStore.analyzeFile(data.tmp_file);
        }
      }} />
    </div>
  )
};

Import.defaultProps = {};

Import.propTypes = {}

export default observer(Import);
